(function () {
  if (window.__deferredSectionVideoInitialized) return;
  window.__deferredSectionVideoInitialized = true;

  const isMobileViewport = () => window.matchMedia('(max-width: 749px)').matches;

  const isForCurrentViewport = video => {
    if (!video) return false;
    const mobile = isMobileViewport();
    if (video.closest('.small-hide') && mobile) return false;
    if (video.closest('.small-up-hide') && !mobile) return false;
    return true;
  };

  const hydrateVideo = video => {
    if (!video || video.dataset.deferredHydrated === 'true') return;
    if (!isForCurrentViewport(video)) return;

    let hasChanges = false;
    video.querySelectorAll('source[data-src]').forEach(source => {
      if (!source.getAttribute('src')) {
        source.setAttribute('src', source.dataset.src);
        hasChanges = true;
      }
    });

    if (hasChanges) {
      video.load();
    }

    if (!video.dataset.posterRevealBound) {
      video.dataset.posterRevealBound = 'true';
      video.addEventListener('playing', () => {
        video.classList.add('is-playing');
      }, { once: true });
    }

    if (video.hasAttribute('autoplay')) {
      video.play().catch(() => {});
    }

    video.dataset.deferredHydrated = 'true';
  };

  const initDeferredVideos = root => {
    const scope = root || document;
    const videos = scope.querySelectorAll('video.js-deferred-section-video');
    if (!videos.length) return;

    if (!('IntersectionObserver' in window)) {
      videos.forEach(hydrateVideo);
      return;
    }

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          const video = entry.target;
          hydrateVideo(video);
          observer.unobserve(video);
        });
      },
      { rootMargin: '200px 0px', threshold: 0.01 }
    );

    videos.forEach(video => {
      if (video.dataset.deferredObserverBound === 'true') return;
      video.dataset.deferredObserverBound = 'true';
      observer.observe(video);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initDeferredVideos(document));
  } else {
    initDeferredVideos(document);
  }

  document.addEventListener('shopify:section:load', event => {
    initDeferredVideos(event.target);
  });
})();
